enum InviteActionTypeEnum {
  Button = 0,
  Link = 1,
}

export default InviteActionTypeEnum;
